import instance from "../../api/Api";

/**
 *
 * @returns currency configuration such as pairs , exchanges and etc.
 */
export const config = () => {
  return instance.get("/configure/configure");
};

/**
 *
 * @param {object} data selected_indicators
 * @returns
 */
export const professionalSignal = (data) => {
  return instance.post("/signal/update-professional/", data);
};

/**
 * Retrieves a list of currency exchanges.
 *
 * @return {Promise} A Promise that resolves with the list of currency exchanges.
 */
export const getExchanges = () => {
  return instance.get("v1/currencies/exchanges/").then((res) => res.data);
};

/**
 * Retrieves a list of currency pairs.
 *
 * @return {Promise}  A Promise that resolves with the list of currency pairs.
 */
export const getPairs = () => {
  return instance.get("v1/currencies/pairs/").then((res) => res.data);
};

/**
 * Retrieves a list of currency assets.
 *
 * @return {Promise} A Promise that resolves with the list of currency assets.
 */
export const getAssets = (params = {}) => {
  const safeParams = params && typeof params === "object" ? params : {};
  return instance
    .get("v1/currencies/assets/", { params: safeParams })
    .then((res) => res.data);
};

/**
 * Retrieves a list of currency strategies.
 *
 * @return {Promise} A Promise that resolves with the list of currency strategies.
 */
export const getStrategies = async () => {
  try {
    const { data } = await instance.get("v1/strategies/");
    return data;
  } catch (error) {
    throw error;
  }
};

/**
 * Creates a new strategy by sending a POST request to the "v1/strategy/" endpoint.
 *
 * @param {Object} data - Position, indicators and name.
 * @return {Promise} A Promise that resolves with the response data if the request is successful, or rejects with an error if the request fails.
 */
export const createStrategy = async (data) => {
  try {
    const { data: response } = await instance.post("v1/strategy/", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Deletes a strategy by sending a DELETE request to the "v1/strategies/{id}" endpoint.
 *
 * @param {string} id - The ID of the strategy to delete.
 * @return {Promise<Object>} A Promise that resolves with the response data if the request is successful, or rejects with an error if the request fails.
 */
export const deleteStrategy = async (id) => {
  try {
    const { data: response } = await instance.delete(`v1/strategies/${id}/`);
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 *
 * @param {number} id - The ID of strategy's indicator.
 * @param {array} data - The array of indicators
 * @returns {Promise} A Promise that return updated strategy data.
 */
export const strategyIndicatorToggle = async (id, data) => {
  try {
    const { data: response } = await instance.post(
      `v1/strategies/${id}/indicator-toggle/`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Retrieves a strategy by its ID from the API.
 *
 * @param {string} strategy_id - The ID of the strategy to retrieve.
 * @return {Promise<Object>} A Promise that resolves with the strategy data if the request is successful, or rejects with an error if the request fails.
 *
 */
export const getStrategy = async (strategy_id) => {
  try {
    const { data } = await instance.get(`v1/strategies/${strategy_id}/`);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
